import { defineComponent as x, ref as p, provide as u, inject as s, onBeforeUnmount as T, createElementBlock as g, openBlock as B, mergeProps as I, unref as e, createElementVNode as S, createVNode as m, normalizeClass as K, renderSlot as W, withCtx as f } from "vue";
import { classesFromBreakpointProps as b } from "../../breakpoints.js";
import o from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Toolbar/toolbar.js";
import E from "./ToolbarExpandableContent.vue2.js";
import d from "./ToolbarGroup.vue2.js";
import { ToolbarExpandedKey as F, ToolbarShowClearFiltersButtonKey as P, ToolbarClearFilterButtonTextKey as h } from "./Toolbar.vue2.js";
import { useOUIAProps as L } from "../../helpers/ouia.js";
const M = Symbol("ToolbarContentExpandableRefKey"), R = Symbol("ToolbarContentLabelContainerRefKey"), j = /* @__PURE__ */ x({
  name: "PfToolbarContent",
  __name: "ToolbarContent",
  props: {
    alignItems: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean },
    visibility: {},
    visibilitySm: {},
    visibilityMd: {},
    visibilityLg: {},
    visibilityXl: {},
    visibility2xl: {},
    rowWrap: {},
    rowWrapSm: {},
    rowWrapMd: {},
    rowWrapLg: {},
    rowWrapXl: {},
    rowWrapXl2: {}
  },
  setup(c) {
    const t = c, y = L({ id: t.ouiaId, safe: t.ouiaSafe }), r = p(null);
    u(M, r);
    const n = p(null);
    u(R, n);
    const C = s(F), v = s(P), w = s(h);
    return T(() => {
      r.value && (r.value = null), n.value && (n.value = null);
    }), (l, a) => (B(), g("div", I(e(y), {
      class: [
        e(o).toolbarContent,
        e(b)(t, ["visibility"], e(o), { short: !0 })
      ]
    }), [
      S("div", {
        class: K([
          e(o).toolbarContentSection,
          e(b)(t, ["rowWrap"], e(o), { short: !0 }),
          {
            [e(o).modifiers.alignItemsCenter]: l.alignItems === "center",
            [e(o).modifiers.alignItemsStart]: l.alignItems === "start",
            [e(o).modifiers.alignItemsBaseline]: l.alignItems === "baseline"
          }
        ])
      }, [
        W(l.$slots, "default")
      ], 2),
      m(E, {
        expanded: e(C),
        "show-clear-filters-button": e(v),
        "clear-filters-button-text": e(w)
      }, {
        "label-container": f(() => [
          m(d, {
            onMounted: a[1] || (a[1] = (i) => n.value = i)
          })
        ]),
        default: f(() => [
          m(d, {
            onMounted: a[0] || (a[0] = (i) => r.value = i)
          })
        ]),
        _: 1
      }, 8, ["expanded", "show-clear-filters-button", "clear-filters-button-text"])
    ], 16));
  }
});
export {
  M as ToolbarContentExpandableRefKey,
  R as ToolbarContentLabelContainerRefKey,
  j as default
};
